import React, { useContext, createRef } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './Form.css';
import { SearchContext } from '../Provider/Provider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const SearchForm = () => {
  const { term, setTerm, search, reset, query, setQuery, searching } = useContext(SearchContext);
  //const [error, setError] = useState({"message": 'An error has occured.', "details": ''});
  const searchTerm = createRef();


  const updateQueryString = () => {
    const params = new URLSearchParams(window.location.search)
    let keyword = params.get('keyword')
    let partial = '';
    
    if (keyword && keyword !== null && keyword !== '') {

      params.delete('keyword')
      params.set("keyword", query.query.simple_query_string.query)
      if (query.query.simple_query_string.query) {
        partial = `?${params.toString()}`
      }
    } else {
      params.set('keyword', query.query.simple_query_string.query)
      partial = `?${params.toString()}`
    }

    window.history.pushState(
      null,
      '',
      `${window.location.pathname}${partial}`
    );
  }
  
  /**
   * Searches key term on Elasticsearch.
   * 
   * @param {Event} event The submit event.
   */
  const handleSubmit = (event) => {
    event.preventDefault();
    let from = 0;
    updateQueryString();
    search(from);
  };

  /**
   * Update query string from web browser history.
   * 
   */
  const searchParamsChange = () => {
    const params = new URLSearchParams(window.location.search)
    let keyword = params.get('keyword')

    if (keyword && keyword !== null && keyword !== '') {
      let q = query;
      q.query.simple_query_string.query = keyword;
      let from = 0;
      setTerm(keyword)
      setQuery(keyword);
      search(from);
    } else {
      handleReset()
    }

  }

  React.useEffect(() => {
    window.addEventListener('popstate', searchParamsChange)
    return () => {
        document.removeEventListener('popstate', searchParamsChange);
    }
  }, [query]);


  /**
   * Resets input textbox.
   * 
   * @param {Event} event The reset click event.
   */
  const handleReset = (event) => {
    let q = query;
    q.query.simple_query_string.query = '';
    setQuery(q);
    reset();
  }

  
  /**
   * Update Elasticsearch query string param.
   * 
   * @param {Event} event The keyup event.
   */
  const handleInput = event => {
    setTerm(event.target.value);

    let q = query;
    q.query.simple_query_string.query = event.target.value;
    setQuery(q);
  };

  /**
   * Get parameters from query string and run search.
   */
  React.useEffect(() => {

    const params = new URLSearchParams(window.location.search)
    let keyword = params.get('keyword')
    
    if (keyword && keyword !== null && keyword !== '') {
      query.query.simple_query_string.query = keyword;
      let from = 0;
      setTerm(keyword)
      setQuery(keyword);
      search(from);
    }
  }, [])

  

  return (
    <div className="Form">
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={9} lg={10}>
            <Form.Control type="text" onChange={handleInput} value={term} placeholder="Search..." ref={searchTerm} />
          </Col>
          <Col md={3} lg={2}>
            <Button variant="primary" type="submit" className="green-btn">
              {searching == true ? 
                <FontAwesomeIcon icon="spinner" pulse /> :
                <FontAwesomeIcon icon="search" /> 
              }
              Search
            </Button>
            {/*<Button variant="primary" onClick={handleReset}>Reset</Button>*/}
          </Col>
        </Row>
      </Form>
    </div>
  );
}
export default SearchForm;
